import { FC } from 'react';

import { ICartConfirmation } from './types';

export const CartConfirmation: FC<ICartConfirmation> = () => null;
